'use strict';

import './partnerMarketplace.scss';
import template from './partnerMarketplace.template.html';

function directive(gpt, viewport) {
    return {
        restrict: 'E',
        scope: {
            slotNames: '=',
            targeting: '@',
            isMobileInstance: '<'
        },
        template,
        link
    };

    function link (scope, element) {
        function init() {
            scope.pmShouldRender = false;
            scope.adsLoaded = false;
            scope.breakpoint = getViewportBreakpoint();

            if (testBreakpointForPmVisibility()) { scope.pmShouldRender = true; }
        }

        init();

        // Add a listener to the gpt pubads service...
        if (gpt.cmd){
            gpt.cmd.push(function () {
                gpt.pubads().addEventListener("slotRenderEnded", testPmVisibility);
            });
        } else {
            gpt.pubads().addEventListener("slotRenderEnded", testPmVisibility);
        }

        const auPathRegex = new RegExp('mktplc\.[1-5]\/' + scope.breakpoint);

        function testPmVisibility(event) {
            let auPath = event.slot.getAdUnitPath();
            // If it's a marketplace ad...
            if (auPathRegex.test(auPath) && !event.isEmpty) {
                if (!scope.adsLoaded) { scope.adsLoaded = true; }
                testPmSlotVisibility(auPath);
            }
        }

        const pmPlacementWords = ['One', 'Two', 'Three', 'Four', 'Five'];
        const pmPlacementRegex = /(mktplc\.[1-5])/; //match 'mktplc.#' from slot name

        function testPmSlotVisibility(slotPath) {
            const pmPlacementMatch = slotPath.match(pmPlacementRegex); //attempt to find match for 'mktplc.#'

            // if match, grab placement # from slot name
            const pmPlacementNum = pmPlacementMatch ? pmPlacementMatch[0].slice(-1) : null;

            if (pmPlacementNum && (pmPlacementNum <= pmPlacementWords.length)) {
                const pmPlacementWord = pmPlacementWords[pmPlacementNum - 1]; //map placement # -> word
                const pmPlacementString = 'pmPlacement' + pmPlacementWord + 'Filled';

                scope[pmPlacementString] = true; //toggle ng-show for container div
            }
        }

        function testBreakpointForPmVisibility() {
            return !!(
                (viewport.isAtLeastDesktop() && !scope.isMobileInstance) ||
                ((viewport.width() <= viewport.maxWidth.tablet) && scope.isMobileInstance)
            );
        }

        function getViewportBreakpoint() {
            let eligibleWidths = [];

            let widths = Object.keys(viewport.maxWidth);
            let currentWidth = viewport.width();

            eligibleWidths = widths.filter(key => {
                if (key === 'landscape') { return false; }
                return currentWidth < viewport.maxWidth[key];
            });

            return (eligibleWidths[0] && eligibleWidths[0].length) ? eligibleWidths[0] : 'large-desktop';
        }
    }
}

directive.$inject = ['gptService', 'viewport'];

export default directive;